<template>
  <div class="area-confirm">
    <div class="area-confirm-shadow" @click="hidePopup"></div>
    <div class="area-confirm-main">
      <p class="main-title">{{ letter.areaLimitSwitchRegion }}</p>
      <div class="main-content">
        <template v-if="!havePayWay">
          <div class="main-tips">
            <p>{{ letter.noPayWay }}</p>
          </div>
        </template>
        <template v-else-if="isLocationDiff && !nextLocationName && canSwitch">
          <div class="main-tips">
            <p>{{ letter.areaLimitInconsistencyWarning }}</p>
            <p>{{ letter.areaLimitPromptToSwitch }}</p>
          </div>
        </template>
        <p class="main-content-title">
          {{ letter.areaLimitPreSwitchRegionCurrency }}
        </p>
        <template>
          <div class="main-box">
            <div class="box-area">
              <p>{{ letter.areaLimitRegion }}</p>
              <p class="now-text">{{ curLocationName }}</p>
            </div>
            <div class="box-area short" v-if="showCurZipCode">
              <p>zipcode</p>
              <p class="now-text">{{ zipCode }}</p>
            </div>
            <div class="box-area">
              <p>{{ letter.areaLimitCurrency }}</p>
              <p class="now-text">{{ defaultCurrency }}</p>
            </div>
          </div>
        </template>
        <template v-if="nextLocationName">
          <p class="main-content-title">
            {{ letter.areaLimitPostSwitchRegionCurrency }}
          </p>
          <div class="main-box active">
            <div class="box-area">
              <p>{{ letter.areaLimitRegion }}</p>
              <p class="next-text">{{ nextLocationName }}</p>
            </div>
            <div class="box-area short active" v-if="showNextZipCode">
              <p>zipcode</p>
              <p class="next-text">{{ nextZipCode }}</p>
            </div>
            <div class="box-area active">
              <p>{{ letter.areaLimitCurrency }}</p>
              <p class="next-text">{{ nextCurrency }}</p>
            </div>
          </div>
        </template>
        <template v-if="showCurZipCode">
          <p class="main-box main-zipcode-btn" @click="goUpdateZipCode">
            {{ letter.zipCodeSwitchZipCode }}
          </p>
        </template>
        <div class="main-tips" v-if="!canSwitch">
          <p>{{ letter.areaLimitNoRemainingSwitches }}</p>
          <p>{{ letter.areaLimitUnableToSwitchThisYear }}</p>
        </div>
        <template v-if="!nextLocationName">
          <p>{{ letter.areaLimitNote }}</p>
          <p>{{ letter.areaLimitSwitchLimitationTwice }}</p>
          <p>{{ letter.areaLimitPostSwitchCoupon }}</p>
          <div class="main-btn-wrap">
            <a
              v-if="canSwitch"
              class="confirm btn"
              href="javascript:;"
              @click="showAreaSwitch('V1')"
            >
              {{ letter.areaLimitNavigateToSwitch }}
            </a>
            <a v-else class="disabled btn" href="javascript:;">
              {{ letter.areaLimitCannotSwitch }}
            </a>
          </div>
        </template>
        <template v-else>
          <div class="main-btn-wrap">
            <a
              class="confirm btn"
              href="javascript:;"
              @click="confirmSwitchArea(gameId, 'V1')"
            >
              {{ letter.areaLimitConfirm }}
            </a>
          </div>
          <p class="main-tips main-btn-tips">
            {{
              letter.areaLimitRemainingSwitches.replace(
                '\${times}',
                modifyCount
              )
            }}
          </p>
        </template>
      </div>
      <a href="javascript:;" class="main-close" @click="hidePopup"></a>
    </div>
    <transition name="fade">
      <AreaSwitchPopup
        v-if="showAreaSwitchPopup"
        @hidePopup="cancelAreaSwitchPopup"
        @getAreaSwithInfo="getAreaSwithInfo"
        :zipCode="zipCode"
      ></AreaSwitchPopup>
    </transition>
  </div>
</template>

<script>
import AreaSwitchPopup from '@components/officialStore/paytype/AreaSwitchPopup';
import areaLimit from '@mixins/areaLimit';
import { mapState } from 'vuex';
export default {
  name: 'AreaConfirmPopup',
  mixins: [areaLimit],
  props: {
    havePayWay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      letter: state => state.letter,
      locationModifyCount: state => state.locationModifyCount,
      maxLocationModifyCount: state => state.maxLocationModifyCount,
      currency: state => state.paytype?.show_currency,
      zipCode: state => state.zipCode,
      ipLocation: state => state.ipLocation,
      defaultCurrency: state => state.defaultCurrency
    }),
    canSwitch() {
      // 如果没有支付方式/最大切换次数大于0并且当前切换次数小于最大切换次数才可切换
      return (
        !this.havePayWay ||
        (this.maxLocationModifyCount &&
          this.locationModifyCount < this.maxLocationModifyCount)
      );
    },
    isLocationDiff() {
      return this.ipLocation && this.ipLocation != this.curLocationVal;
    },
    modifyCount() {
      return this.maxLocationModifyCount
        ? this.maxLocationModifyCount - this.locationModifyCount
        : 0;
    },
  },
  methods: {},
  components: {
    AreaSwitchPopup
  }
};
</script>
<style lang="scss" scoped>
@import '@assets/scss/officialStore/_dimen.scss';

.area-confirm {
  z-index: 21;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }

  &-main {
    position: absolute;
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    @psetbg ('area-limit-bg.png', true, false);
    background-size: 100% 100%;
  }
}

.main {
  &-close {
    position: absolute;
    right: 32px;
    top: 27px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    @psetbg ('close.png');
  }

  &-title {
    margin-top: 70px;
    background-image: -webkit-linear-gradient(
      top,
      var(--area-limit-title-color-top),
      var(--area-limit-title-color-bottom)
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    font-size: 40px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
  }

  &-content {
    font-size: 24px;
    text-align: start;
    padding: 60px 32px;
    line-height: 1.5;
    margin-bottom: 160px;
    color: var(--area-limit-main-text-color);
  }

  &-content-title {
    font-size: 28px;
    line-height: 36px;
    font-weight: bold;
    color: var(--area-limit-main-title-color);
  }

  &-box {
    width: 595px;
    display: flex;
    margin: 38px auto 17px;
    background-color: var(--area-limit-now-box-bg-color);
    border-radius: 6px;
    border: solid 2px;
    border-color: var(--area-limit-now-box-border-color);

    .box-area {
      font-size: 22px;
      color: #999999;
      width: 50%;
      text-align: start;
      padding: 14px 22px;

      .now-text {
        font-size: 28px;
        color: var(--area-limit-now-box-highlight-color);
      }

      .next-text {
        font-size: 28px;
        color: var(--area-limit-next-box-highlight-color);
      }

      &.short {
        width: 25%;
      }
    }

    .box-area + .box-area {
      border-left: 2px solid #999999;
    }
  }

  &-zipcode-btn {
    margin-top: 0;
    justify-content: center;
    height: 45px;
    line-height: 45px;
    color: #fefefe;
    cursor: pointer;
  }

  &-tips {
    text-align: center;
    font-size: 24px;
    line-height: 36px;
    color: var(--area-limit-main-tips-color);
    margin-bottom: 30px;
  }

  &-btn-wrap {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 65px;
    display: flex;
    justify-content: center;
    align-items: center;

    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      font-size: 28px;
      color: #fff;
      cursor: pointer;
    }

    .confirm {
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      @psetbg ('area-limit-btn.png');
    }

    .disabled {
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      @psetbg ('area-limit-btn-disabled.png');
    }
  }

  &-btn-tips {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 25px;
    text-align: center;
    margin: 0;
  }
}

.active {
  border-color: var(--area-limit-next-box-border-color);
  background-color: var(--area-limit-next-box-bg-color);
}
</style>
